(() => {
  const SELECTOR = "[data-ineffable-workshop]";
  const MOBILE_QUERY = "(max-width: 749px)";

  const clamp = (number, minimum, maximum) => {
    return Math.min(
      Math.max(number, minimum),
      maximum
    );
  };

  const smootherStep = (value) => {
    const x = clamp(value, 0, 1);

    return (
      x *
      x *
      x *
      (
        x *
        (
          x * 6 -
          15
        ) +
        10
      )
    );
  };

  function initializeWorkshop(section) {
    if (
      !section ||
      section.dataset.workshopInitialized === "true"
    ) {
      return;
    }

    const scrollStage =
      section.querySelector(
        ".ineffable-workshop__scroll-stage"
      );

    const stickyStage =
      section.querySelector(
        ".ineffable-workshop__sticky-stage"
      );

    const introPanel =
      section.querySelector(
        ".ineffable-workshop__intro-panel"
      );

    const introVeil =
      section.querySelector(
        ".ineffable-workshop__intro-veil"
      );

    const identity =
      section.querySelector(
        ".ineffable-workshop__identity"
      );

    const destinations =
      section.querySelector(
        ".ineffable-workshop__destinations"
      );

    const destinationCards =
      Array.from(
        section.querySelectorAll(
          "[data-workshop-destination]"
        )
      );

    const revealLabel =
      section.querySelector(
        ".ineffable-workshop__reveal-label"
      );

    if (
      !scrollStage ||
      !stickyStage ||
      !introPanel ||
      !destinations
    ) {
      console.warn(
        "Mr. Ineffable Workshop could not initialize because required elements are missing."
      );

      return;
    }

    section.dataset.workshopInitialized =
      "true";

    document.documentElement.classList.add(
      "ineffable-home-active"
    );

    document.body.classList.add(
      "ineffable-home-active"
    );

    const sectionWrapper =
      section.closest(".shopify-section");

    const isMobile =
      window.matchMedia(
        MOBILE_QUERY
      ).matches;

    /*
      ==================================================
      MOBILE LAUNCH MODE
      ==================================================

      No scroll-controlled reveal.

      1. Opening screen appears immediately.
      2. Hold for 2.5 seconds.
      3. Fade/lift for 0.8 seconds.
      4. Destination grid remains.
      5. Workshop occupies one viewport only.
    */

    if (isMobile) {
      initializeMobileLaunchMode();
      return;
    }

    /*
      ==================================================
      DESKTOP SCROLL MODE
      ==================================================
    */

    initializeDesktopScrollMode();

    /*
      ==================================================
      MOBILE
      ==================================================
    */

    function initializeMobileLaunchMode() {
      /*
        Keep the workshop to one viewport.

        100dvh is preferred on modern mobile
        browsers. 100vh remains as a fallback.
      */

      scrollStage.style.setProperty(
        "height",
        "100vh",
        "important"
      );

      scrollStage.style.setProperty(
        "height",
        "100dvh",
        "important"
      );

      scrollStage.style.setProperty(
        "min-height",
        "100vh",
        "important"
      );

      scrollStage.style.setProperty(
        "min-height",
        "100dvh",
        "important"
      );

      section.style.setProperty(
        "height",
        "100vh",
        "important"
      );

      section.style.setProperty(
        "height",
        "100dvh",
        "important"
      );

      section.style.setProperty(
        "min-height",
        "100vh",
        "important"
      );

      section.style.setProperty(
        "min-height",
        "100dvh",
        "important"
      );

      section.style.setProperty(
        "overflow",
        "hidden",
        "important"
      );

      if (sectionWrapper) {
        sectionWrapper.style.setProperty(
          "height",
          "100vh",
          "important"
        );

        sectionWrapper.style.setProperty(
          "height",
          "100dvh",
          "important"
        );

        sectionWrapper.style.setProperty(
          "min-height",
          "100vh",
          "important"
        );

        sectionWrapper.style.setProperty(
          "min-height",
          "100dvh",
          "important"
        );

        sectionWrapper.style.setProperty(
          "overflow",
          "hidden",
          "important"
        );
      }

      stickyStage.style.setProperty(
        "position",
        "relative",
        "important"
      );

      stickyStage.style.setProperty(
        "top",
        "auto",
        "important"
      );

      stickyStage.style.setProperty(
        "height",
        "100vh",
        "important"
      );

      stickyStage.style.setProperty(
        "height",
        "100dvh",
        "important"
      );

      stickyStage.style.setProperty(
        "min-height",
        "0",
        "important"
      );

      stickyStage.style.setProperty(
        "overflow",
        "hidden",
        "important"
      );

      /*
        DESTINATIONS

        Make the final state available from
        the beginning underneath the opening.
      */

      destinations.style.setProperty(
        "opacity",
        "1",
        "important"
      );

      destinations.style.setProperty(
        "filter",
        "none",
        "important"
      );

      destinations.style.setProperty(
        "transform",
        "none",
        "important"
      );

      destinations.style.setProperty(
        "visibility",
        "visible",
        "important"
      );

      destinationCards.forEach(
        (card) => {
          card.style.setProperty(
            "transform",
            "none",
            "important"
          );

          card.style.setProperty(
            "visibility",
            "visible",
            "important"
          );

          card.style.setProperty(
            "pointer-events",
            "auto",
            "important"
          );

          card.setAttribute(
            "aria-hidden",
            "false"
          );

          card.setAttribute(
            "tabindex",
            "0"
          );

          card.classList.add(
            "is-revealed"
          );
        }
      );

      /*
        Hide the old scroll reveal label.
      */

      if (revealLabel) {
        revealLabel.style.setProperty(
          "display",
          "none",
          "important"
        );
      }

      /*
        OPENING SCREEN

        Force the presentation layer to be
        completely opaque on mobile.

        This prevents the four cards from
        showing through during the hold.
      */

      introPanel.style.setProperty(
        "display",
        "flex",
        "important"
      );

      introPanel.style.setProperty(
        "visibility",
        "visible",
        "important"
      );

      introPanel.style.setProperty(
        "opacity",
        "1",
        "important"
      );

      introPanel.style.setProperty(
        "transform",
        "translate3d(0, 0, 0)",
        "important"
      );

      introPanel.style.setProperty(
        "pointer-events",
        "none",
        "important"
      );

      introPanel.style.setProperty(
        "z-index",
        "20",
        "important"
      );

      introPanel.style.setProperty(
        "transition",
        "none",
        "important"
      );

      if (introVeil) {
        introVeil.style.setProperty(
          "opacity",
          "1",
          "important"
        );

        /*
          Use the existing workshop panel
          background instead of introducing
          a new color.
        */

        introVeil.style.setProperty(
          "background-color",
          "var(--iw-panel-background)",
          "important"
        );
      }

      if (identity) {
        identity.style.setProperty(
          "opacity",
          "1",
          "important"
        );

        identity.style.setProperty(
          "transform",
          "none",
          "important"
        );
      }

      /*
        Allow the browser to paint the
        opening screen before installing
        the transition.
      */

      window.requestAnimationFrame(
        () => {
          window.requestAnimationFrame(
            () => {
              introPanel.style.setProperty(
                "transition",
                "opacity 800ms ease, transform 800ms cubic-bezier(0.22, 1, 0.36, 1)",
                "important"
              );
            }
          );
        }
      );

      /*
        Begin reveal after 2.5 seconds.
      */

      window.setTimeout(
        () => {
          introPanel.style.setProperty(
            "opacity",
            "0",
            "important"
          );

          introPanel.style.setProperty(
            "transform",
            "translate3d(0, -4%, 0)",
            "important"
          );
        },
        2500
      );

      /*
        Completely remove the opening layer
        after the fade has finished.

        This guarantees that it cannot block
        taps or scrolling.
      */

      window.setTimeout(
        () => {
          introPanel.style.setProperty(
            "display",
            "none",
            "important"
          );

          introPanel.style.setProperty(
            "visibility",
            "hidden",
            "important"
          );

          introPanel.style.setProperty(
            "pointer-events",
            "none",
            "important"
          );
        },
        3350
      );
    }

    /*
      ==================================================
      DESKTOP ORIGINAL SCROLL EXPERIENCE
      ==================================================
    */

    function initializeDesktopScrollMode() {
      const configuredScrollHeight =
        Number(
          section.dataset.scrollHeight ||
          320
        );

      const safeScrollHeight =
        Number.isFinite(
          configuredScrollHeight
        )
          ? Math.max(
              300,
              configuredScrollHeight
            )
          : 320;

      function applyRequiredHeights() {
        const heightValue =
          `${safeScrollHeight}vh`;

        scrollStage.style.setProperty(
          "height",
          heightValue,
          "important"
        );

        scrollStage.style.setProperty(
          "min-height",
          heightValue,
          "important"
        );

        section.style.setProperty(
          "min-height",
          heightValue,
          "important"
        );

        section.style.setProperty(
          "height",
          "auto",
          "important"
        );

        section.style.setProperty(
          "overflow",
          "visible",
          "important"
        );

        if (sectionWrapper) {
          sectionWrapper.style.setProperty(
            "min-height",
            heightValue,
            "important"
          );

          sectionWrapper.style.setProperty(
            "height",
            "auto",
            "important"
          );

          sectionWrapper.style.setProperty(
            "overflow",
            "visible",
            "important"
          );
        }

        stickyStage.style.setProperty(
          "height",
          "100vh",
          "important"
        );
      }

      applyRequiredHeights();

      let targetProgress = 0;
      let renderedProgress = 0;
      let animationFrame = null;

      function calculateProgress() {
        const rectangle =
          scrollStage
            .getBoundingClientRect();

        const viewportHeight =
          window.innerHeight ||
          document.documentElement
            .clientHeight;

        const scrollableDistance =
          scrollStage.offsetHeight -
          viewportHeight;

        if (
          scrollableDistance <= 0
        ) {
          return 0;
        }

        return clamp(
          -rectangle.top /
            scrollableDistance,
          0,
          1
        );
      }

      function render(progress) {
        const liftLinear =
          clamp(
            (
              progress -
              0.015
            ) /
              0.8,
            0,
            1
          );

        const liftProgress =
          smootherStep(
            liftLinear
          );

        const destinationLinear =
          clamp(
            progress /
              0.76,
            0,
            1
          );

        const destinationProgress =
          smootherStep(
            destinationLinear
          );

        const contentProgress =
          clamp(
            (
              progress -
              0.42
            ) /
              0.28,
            0,
            1
          );

        /*
          Opening panel
        */

        const panelTranslate =
          liftProgress *
          -106;

        const panelScale =
          1 -
          liftProgress *
            0.006;

        const panelOpacity =
          1 -
          clamp(
            (
              liftProgress -
              0.94
            ) /
              0.06,
            0,
            1
          );

        introPanel.style.transform =
          `translate3d(
            0,
            ${panelTranslate}%,
            0
          ) scale(${panelScale})`;

        introPanel.style.opacity =
          panelOpacity.toFixed(3);

        /*
          Identity
        */

        if (identity) {
          const identityScale =
            1 -
            liftProgress *
              0.045;

          const identityOpacity =
            1 -
            clamp(
              (
                liftProgress -
                0.9
              ) /
                0.1,
              0,
              1
            );

          identity.style.transform =
            `scale(${identityScale})`;

          identity.style.opacity =
            identityOpacity.toFixed(3);
        }

        /*
          Opening veil
        */

        if (introVeil) {
          const sectionStyles =
            getComputedStyle(
              section
            );

          const initialOpacity =
            Number.parseFloat(
              sectionStyles
                .getPropertyValue(
                  "--iw-opening-opacity"
                )
            ) || 0.91;

          const veilOpacity =
            Math.max(
              0,
              initialOpacity -
                liftProgress *
                  0.18
            );

          introVeil.style.opacity =
            veilOpacity.toFixed(3);
        }

        /*
          Destination field
        */

        const sectionStyles =
          getComputedStyle(
            section
          );

        const openingBlur =
          Number.parseFloat(
            sectionStyles
              .getPropertyValue(
                "--iw-opening-blur"
              )
          ) || 5;

        const destinationOpacity =
          0.34 +
          destinationProgress *
            0.66;

        const destinationBlur =
          (
            1 -
            destinationProgress
          ) *
          openingBlur;

        const destinationSaturation =
          0.7 +
          destinationProgress *
            0.3;

        const destinationBrightness =
          0.8 +
          destinationProgress *
            0.2;

        const destinationScale =
          1.035 -
          destinationProgress *
            0.035;

        destinations.style.opacity =
          destinationOpacity
            .toFixed(3);

        destinations.style.filter =
          `blur(${destinationBlur}px) ` +
          `saturate(${destinationSaturation}) ` +
          `brightness(${destinationBrightness})`;

        destinations.style.transform =
          `scale(${destinationScale})`;

        /*
          Individual destination cards
        */

        destinationCards.forEach(
          (
            card,
            index
          ) => {
            const stagger =
              index *
              0.035;

            const cardProgress =
              smootherStep(
                clamp(
                  (
                    destinationProgress -
                    stagger
                  ) /
                    Math.max(
                      0.01,
                      1 -
                        stagger
                    ),
                  0,
                  1
                )
              );

            const cardOffset =
              42 -
              cardProgress *
                42;

            card.style.transform =
              `translate3d(
                0,
                ${cardOffset}px,
                0
              )`;

            const isInteractive =
              progress >=
              0.7;

            card.style.pointerEvents =
              isInteractive
                ? "auto"
                : "none";

            card.setAttribute(
              "aria-hidden",
              isInteractive
                ? "false"
                : "true"
            );

            card.setAttribute(
              "tabindex",
              isInteractive
                ? "0"
                : "-1"
            );

            card.classList.toggle(
              "is-revealed",
              contentProgress >
                index *
                  0.07
            );
          }
        );

        /*
          Optional reveal label
        */

        if (revealLabel) {
          const fadeIn =
            clamp(
              (
                progress -
                0.26
              ) /
                0.14,
              0,
              1
            );

          const fadeOut =
            1 -
            clamp(
              (
                progress -
                0.54
              ) /
                0.16,
              0,
              1
            );

          revealLabel.style.opacity =
            (
              fadeIn *
              fadeOut
            ).toFixed(3);
        }
      }

      /*
        Smooth desktop scroll response
      */

      function animationLoop() {
        const difference =
          targetProgress -
          renderedProgress;

        renderedProgress +=
          difference *
          0.11;

        if (
          Math.abs(
            difference
          ) <
          0.0001
        ) {
          renderedProgress =
            targetProgress;
        }

        render(
          renderedProgress
        );

        if (
          Math.abs(
            targetProgress -
            renderedProgress
          ) >
          0.0001
        ) {
          animationFrame =
            window.requestAnimationFrame(
              animationLoop
            );
        } else {
          animationFrame = null;
        }
      }

      function requestUpdate() {
        targetProgress =
          calculateProgress();

        if (
          animationFrame === null
        ) {
          animationFrame =
            window.requestAnimationFrame(
              animationLoop
            );
        }
      }

      section._ineffableWorkshopUpdate =
        requestUpdate;

      window.addEventListener(
        "scroll",
        requestUpdate,
        {
          passive: true
        }
      );

      document.addEventListener(
        "scroll",
        requestUpdate,
        {
          passive: true,
          capture: true
        }
      );

      window.addEventListener(
        "resize",
        () => {
          applyRequiredHeights();
          requestUpdate();
        }
      );

      if (
        window.visualViewport
      ) {
        window.visualViewport
          .addEventListener(
            "resize",
            () => {
              applyRequiredHeights();
              requestUpdate();
            }
          );

        window.visualViewport
          .addEventListener(
            "scroll",
            requestUpdate
          );
      }

      if (
        "ResizeObserver" in
        window
      ) {
        const observer =
          new ResizeObserver(
            () => {
              applyRequiredHeights();
              requestUpdate();
            }
          );

        observer.observe(
          section
        );

        if (sectionWrapper) {
          observer.observe(
            sectionWrapper
          );
        }
      }

      targetProgress =
        calculateProgress();

      renderedProgress =
        targetProgress;

      render(
        renderedProgress
      );

      window.requestAnimationFrame(
        () => {
          applyRequiredHeights();
          requestUpdate();
        }
      );

      window.setTimeout(
        () => {
          applyRequiredHeights();
          requestUpdate();
        },
        250
      );
    }
  }

  function initializeAllWorkshops(
    root = document
  ) {
    root
      .querySelectorAll(
        SELECTOR
      )
      .forEach(
        initializeWorkshop
      );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        initializeAllWorkshops();
      }
    );
  } else {
    initializeAllWorkshops();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section =
        event.target.matches?.(
          SELECTOR
        )
          ? event.target
          : event.target
              .querySelector?.(
                SELECTOR
              );

      if (!section) {
        return;
      }

      section.dataset
        .workshopInitialized =
        "false";

      initializeWorkshop(
        section
      );
    }
  );

  document.addEventListener(
    "shopify:block:select",
    (event) => {
      const section =
        event.target.closest?.(
          SELECTOR
        );

      if (
        section &&
        typeof section
          ._ineffableWorkshopUpdate ===
          "function"
      ) {
        section
          ._ineffableWorkshopUpdate();
      }
    }
  );
})();